/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Review4_SubInputs */

const es_landing_review4_sub = /** @type {(inputs: Landing_Review4_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Luces de Navidad desde el mar`)
};

const gl_landing_review4_sub = /** @type {(inputs: Landing_Review4_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Luces de Nadal desde o mar`)
};

const en_landing_review4_sub = /** @type {(inputs: Landing_Review4_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Christmas lights from the sea`)
};

/**
* | output |
* | --- |
* | "Christmas lights from the sea" |
*
* @param {Landing_Review4_SubInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const landing_review4_sub = /** @type {((inputs?: Landing_Review4_SubInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Review4_SubInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_landing_review4_sub(inputs)
	if (locale === "en") return en_landing_review4_sub(inputs)
	return es_landing_review4_sub(inputs)
});